// Colours from the app (lib/Core/constants/app_colors.dart). The $20
// Challenge is colorIndex 6: orange6. Player 1 is red, player 2 blue.
export const ORANGE = '#F09500'; // orange6Highlight
export const ORANGE_LIGHT = '#FFCA70'; // orange6Background
export const ORANGE_DARK = '#CC7F00'; // orange6HighlightDark
export const PLAYER_COLORS = ['#F9350C', '#2FB7F9']; // orange3Highlight, blue1Background
export const VOTE_COLORS = ['#F9350C', '#2FB7F9', '#F09500', '#DC7ECC'];
